import { render, staticRenderFns } from "./customerUpdate.vue?vue&type=template&id=2bebf7a6&"
import script from "./customerUpdate.vue?vue&type=script&lang=js&"
export * from "./customerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports